import React,{Component} from 'react';
import MapLocationListItem from './MapLocationListItem';

class MapLocationList extends Component{

  constructor(props){
    super(props);
    
  }

  render(){
    if(this.props.locations != null  && this.props.locations != undefined && this.props.locations.length > 0 ){
      let locations = this.props.locations;
      
      const locationItems = locations.map((location,index) => {
        
       return <MapLocationListItem location={location} key={index}  showMapLocation={this.props.showMapLocation}></MapLocationListItem>
      });
      return (
        <ul className="MapLocationList">
            {locationItems}
        </ul>
        
      )
    }else{
      return "";
    }
  }
}
export default MapLocationList;
